export default function (state, getters, rootState, rootGetters) {
  if (!state.Sum) return false;
  if (!state.ContragentId) return false;
  if (!state.Number) return false;
  if (!state.OwnerLegalEntityId) return false;
  let data = {};
  if (rootState.certificates.item.id) data.Id = rootState.certificates.item.id;
  if (state.StartDate) data.StartDate = {Serialized: state.StartDate};
  if (state.EndDate) data.EndDate = {Serialized: state.EndDate};
  if (state.IssueDate) data.IssueDate = {Serialized: state.IssueDate};
  if (state.Number) data.Number = state.Number;
  if (state.ContragentType) {
    switch (state.ContragentType) {
      case 1:
        data.ClientId = state.ContragentId;
        break;
      case 2:
        data.PartnerId = state.ContragentId;
        break;
    }
  }
  if (state.PartnerLegalId) data.PartnerLegalId = state.PartnerLegalId;
  if (state.Sum) data.Sum = state.Sum;
  if (state.OwnerLegalEntityId) data.OwnerLegalEntityId = state.OwnerLegalEntityId;
  data.CurrencyId = state.CurrencyId;
  data.Type = state.Type;

  if (state.IsOwner) {
    data.OwnerId = state.OwnerId;
  }

  data.Comment = state.Comment;

  return data;
}
